import { Component, OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario36',
  templateUrl: './formulario36.component.html',
  styleUrls: ['./formulario36.component.css']
})
export class Formulario36Component implements OnInit {
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public propiedad;
  public propietarios;
  public permiso_notariado;
  public arquitectos;
  public superficie_proyecto_modificado;
  public cip;
  public caract_anteproy_loteo;
  public registro_bienes;
  public declaracion;
  public porcentajes_anteproy;
  public loteo_const;
  public permiso_urb;
  public tipo_mod;
  public reso_mod;
  public mod_parcial;
  public caract_proy_mod;
  public planos_mod;
  public totalMz = 0;
  public totalsup = 0;
  public porcentajeSup = 0;
  public cantTotal = 0;


 

//contadores

  public sup_total= 0;
  public sup_total_subdivision = 0 ;
  public sup_total_fusion = 0 ;
  public sup_porc= 0;
 
  

   pages = [1,2,3];

  constructor() {

    
  //CARACTERISTICAS PROYECTO MODIFICADO
  if(JSON.parse(localStorage.getItem("caract_proy_mod"))){
    if (JSON.parse(localStorage.getItem("caract_proy_mod")).length > 0){
      this.caract_proy_mod = JSON.parse(localStorage.getItem("caract_proy_mod"))
    }else{ 
    localStorage.setItem("caract_proy_mod", JSON.stringify([]))
      this.caract_proy_mod = [{lotes_proy_mod:'',mz_proy_mod:'',sup_proy_mod:'',hoja_anexa_mod:''}]
    }
  }
  

  for (let i = 0; i < this.caract_proy_mod.length; i++) {
    
    this.totalMz = this.totalMz + parseInt(this.caract_proy_mod[i].mz_proy_mod);
    this.totalsup = this.totalsup + parseInt(this.caract_proy_mod[i].sup_proy_mod);
  }

  //PORCENTAJES ANTEPROYECTO
  if(JSON.parse(localStorage.getItem("porcentajes_anteproy"))){
    if (JSON.parse(localStorage.getItem("porcentajes_anteproy")).length > 0){
      this.porcentajes_anteproy = JSON.parse(localStorage.getItem("porcentajes_anteproy"))
    }else{ 
    localStorage.setItem("porcentajes_anteproy", JSON.stringify([]))
      this.porcentajes_anteproy = [{sup_predios:'0',porc_predios:'0',cant_predios:'0',sup_areas:'0',porc_areas:'0',cant_areas:'0',sup_equip:'0',porc_equip:'0',cant_equip:'0',sup_valid:'0',porc_valid:'0',cant_valid:'0',sup_reserva:'0',porc_reserva:'0',cant_reserva:'0'}]
    }
  }
  

  for (let i = 0; i < this.porcentajes_anteproy.length; i++) {
    
    this.porcentajeSup = parseInt(this.porcentajes_anteproy[0].sup_predios) + parseInt(this.porcentajes_anteproy[0].sup_areas) + parseInt(this.porcentajes_anteproy[0].sup_equip) + parseInt(this.porcentajes_anteproy[0].sup_valid) + parseInt(this.porcentajes_anteproy[0].sup_reserva);
    this.cantTotal = parseInt(this.porcentajes_anteproy[0].cant_predios) + parseInt(this.porcentajes_anteproy[0].cant_areas) + parseInt(this.porcentajes_anteproy[0].cant_equip) + parseInt(this.porcentajes_anteproy[0].cant_valid) + parseInt(this.porcentajes_anteproy[0].cant_reserva);
  }



  }

   ngOnInit(){

   }

   ngAfterContentChecked(){
    this.ngAfterContentInit();
  }

   ngAfterContentInit() {

    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("tipo_mod"))){
      if (JSON.parse(localStorage.getItem("tipo_mod")).length > 0){ 
        this.tipo_mod = JSON.parse(localStorage.getItem("tipo_mod"));
      }else{
      localStorage.setItem("tipo_mod", JSON.stringify([]))
        this.tipo_mod = [{mod1:'',mod2:'',mod3:'', mod4:''}]
      }
    }
    
    

    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("propiedad"))){
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0){ 
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }else{
       localStorage.setItem("propiedad", JSON.stringify([]))
        this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
      }  
    }

    //PROPIETARIOS
   if(JSON.parse(localStorage.getItem("propietarios"))){
    if (JSON.parse(localStorage.getItem("propietarios")).length > 0){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
    }else{
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
    }
   }

     //PERMISO NOTARIADO
    if(JSON.parse(localStorage.getItem("permiso_notariado"))){
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0){
        this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
      }else{
       localStorage.setItem("permiso_notariado", JSON.stringify([]))
        this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
      }
    }

    //ARQUITECTOS
    if(JSON.parse(localStorage.getItem("arquitectos"))){
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0){
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      }else{ 
       localStorage.setItem("arquitectos", JSON.stringify([]))
        this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
      }
    }

    //CIP
    if(JSON.parse(localStorage.getItem("cip"))){
      if (JSON.parse(localStorage.getItem("cip")).length > 0){
        this.cip = JSON.parse(localStorage.getItem("cip"))
      }else{ 
       localStorage.setItem("cip", JSON.stringify([]))
        this.cip = [{certcip:'',fecha_cip:''}]
      }
    }

    //REGISTRO DE BIENES
    if(JSON.parse(localStorage.getItem("registro_bienes"))){
      if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0){
        this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"))
      }else{ 
       localStorage.setItem("registro_bienes", JSON.stringify([]))
        this.registro_bienes = [{inscrito:'',numero:'',anio:'',bienes:''}]
      }
    }

    //DECLARACION
    if(JSON.parse(localStorage.getItem("declaracion"))){
      if (JSON.parse(localStorage.getItem("declaracion")).length > 0){
        this.declaracion = JSON.parse(localStorage.getItem("declaracion"))
      }else{ 
       localStorage.setItem("declaracion", JSON.stringify([]))
        this.declaracion = [{plano:'',denominado:'',elaborado:'',profesion:''}]
      }
    }

    //PORCENTAJES ANTEPROYECTO
    if(JSON.parse(localStorage.getItem("porcentajes_anteproy"))){
      if (JSON.parse(localStorage.getItem("porcentajes_anteproy")).length > 0){
        this.porcentajes_anteproy = JSON.parse(localStorage.getItem("porcentajes_anteproy"))
      }else{ 
       localStorage.setItem("porcentajes_anteproy", JSON.stringify([]))
        this.porcentajes_anteproy = [{sup_predios:'',porc_predios:'',cant_predios:'',sup_areas:'',porc_areas:'',cant_areas:'',sup_equip:'',porc_equip:'',cant_equip:'',sup_valid:'',porc_valid:'',cant_valid:'',sup_reserva:'',porc_reserva:'',cant_reserva:''}]
      }
    }

    //RESOLUCION MODIFICACION
    if(JSON.parse(localStorage.getItem("reso_mod"))){
      if (JSON.parse(localStorage.getItem("reso_mod")).length > 0){
        this.reso_mod = JSON.parse(localStorage.getItem("reso_mod"))
      }else{ 
       localStorage.setItem("reso_mod", JSON.stringify([]))
        this.reso_mod = [{reso_num:"",fecha_reso:""}]
      }
    }

    //RESOLUCION MODIFICACION
    if(JSON.parse(localStorage.getItem("mod_parcial"))){
      if (JSON.parse(localStorage.getItem("mod_parcial")).length > 0){
        this.mod_parcial = JSON.parse(localStorage.getItem("mod_parcial"))
      }else{ 
       localStorage.setItem("mod_parcial", JSON.stringify([]))
        this.mod_parcial = [{supt_parcial:"",supm_parcial:""}]
      }
    }

    //CARACTERISTICAS PROYECTO MODIFICADO
    if(JSON.parse(localStorage.getItem("caract_proy_mod"))){
      if (JSON.parse(localStorage.getItem("caract_proy_mod")).length > 0){
        this.caract_proy_mod = JSON.parse(localStorage.getItem("caract_proy_mod"))
      }else{ 
       localStorage.setItem("caract_proy_mod", JSON.stringify([]))
        this.caract_proy_mod = [{lotes_proy_mod:'',mz_proy_mod:'',sup_proy_mod:'',hoja_anexa_mod:''}]
      }
    }

    //PLANOS A MODIFICAR
    if(JSON.parse(localStorage.getItem("planos_mod"))){
      if (JSON.parse(localStorage.getItem("planos_mod")).length > 0){
        this.planos_mod = JSON.parse(localStorage.getItem("planos_mod"))
      }else{ 
       localStorage.setItem("planos_mod", JSON.stringify([]))
        this.planos_mod = [{planos_mod:''}]
      }
    }
    
    
    
  }

  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    html2canvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    html2canvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    html2canvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });
    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }
}

